// Where course pictures load from (Mako 2026-10-06, CP5: "Move to storage" + shrink).
// Empty VITE_COURSE_IMG_BASE = the app's own /course-img/ folder (today).
// After scripts/move_course_images.py --upload, set it to the bucket's public URL,
// e.g. https://<project>.supabase.co/storage/v1/object/public/course-images
// The markdown keeps its /course-img/... refs (sync-owned); this swaps them at render.
const BASE = ((import.meta.env.VITE_COURSE_IMG_BASE as string | undefined) || "").replace(/\/$/, "");

export const courseImgSrc = (src?: string): string | undefined => {
  if (!src || !BASE || !src.startsWith("/course-img/")) return src;
  return `${BASE}/${src.slice("/course-img/".length).replace(/\.(webp|png|jpe?g|gif)$/i, ".avif")}`;
};
